import axiosInstance from 'src/utils/axios';

export type LoginHistory = {
  id: string;
  user: { id: string }; // hoặc UserEntities tối giản
  ipAddress?: string;
  deviceModel?: string;
  deviceVendor?: string;
  deviceType?: 'desktop' | 'mobile' | 'tablet' | 'bot';
  browserName?: string;
  browserVersion?: string;
  osName?: string;
  osVersion?: string;
  cpuArchitecture?: string;
  loginTime: string; // ISO string
  logoutTime?: string; // ISO string
  isOnline: boolean;
};

export type CreateLoginHistoryPayload = {
  userId: string;
  ipAddress?: string;
  deviceModel?: string;
  deviceVendor?: string;
  deviceType?: 'desktop' | 'mobile' | 'tablet' | 'bot';
  browserName?: string;
  browserVersion?: string;
  osName?: string;
  osVersion?: string;
  cpuArchitecture?: string;
};

export type Paged<T> = {
  items: T[];
  total: number;
  page: number;
  pageSize: number;
};

const base = '/login-history';

export const loginHistoryApi = {
  create: async (payload: CreateLoginHistoryPayload): Promise<LoginHistory> => {
    const { data } = await axiosInstance.post(base, payload);
    return data;
  },

  logoutById: async (): Promise<LoginHistory> => {
    const { data } = await axiosInstance.get(`${base}/logout`);
    return data;
  },

  closeLatestByUser: async (userId: string): Promise<LoginHistory> => {
    const { data } = await axiosInstance.patch(`${base}/close-latest/by-user`, { userId });
    return data;
  },

  listByUser: async (userId: string, page = 1, pageSize = 20): Promise<Paged<LoginHistory>> => {
    const { data } = await axiosInstance.get(`${base}/by-user/${userId}`, {
      params: { page, pageSize },
    });
    return data;
  },
};
